<template>
    <div class="flex w-full flex-col gap-4">
        <h2 class="text-sm lg:text-4xl font-bold text-blue">{{ agency.Name }}</h2>
        <span class="mb-4 font-bold text-grey-80">
            Branch: <span class="font-normal">{{ branch.town }}</span>
        </span>
        <HorizontalSeparator class="mb-4" />

        <template v-if="!fetching">
            <template v-if="!error">
                <h3 class="mb-2 text-sm lg:text-3xl font-bold text-blue">Contact Details:</h3>
                <AcCard class="mb-8 rounded-md bg-red-450 p-4 font-bold text-white">
                    When you contact this agency please quote:
                    <span class="font-normal">Agency Central</span>
                </AcCard>

                <div class="flex w-full flex-col md:flex-row">
                    <div v-if="telephoneNumber" class="mb-12 flex flex-grow flex-col">
                        <span class="text-xl font-bold text-blue">Telephone:</span>
                        <span class="text-2xl lg:text-5xl text-green">{{ telephoneNumber }}</span>
                    </div>
                    <div v-if="showOOH && outOfHours" class="mb-12 flex flex-grow flex-col">
                        <span class="text-xl font-bold text-blue">Out Of Hours:</span>
                        <span class="text-2xl lg:text-5xl text-green">{{ outOfHours }}</span>
                    </div>
                </div>
            </template>
            <div v-else>
                <h3 class="mb-2 text-xl">Sorry, something went wrong</h3>
                <p> {{ errorMessage }}</p>
            </div>
        </template>
        <div v-else>
            Loading contact information.
        </div>

        <div class="flex w-full flex-col gap-4 lg:w-3/12">
            <InputButton style-type="contact-form" @click="$emit('closeClick')">
                Close this window<br />
                <span class="text-xs"> and return to the listing of agencies </span>
            </InputButton>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import HorizontalSeparator from 'Components/HorizontalSeparator';
import AcCard from 'Components/AcCard';
import InputButton from 'Components/InputButton';
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
    name: 'ContactTelfaxSuccess',
    components: { InputButton, AcCard, HorizontalSeparator },
    data() {
        return {
            fetching: true,
            error: false,
            errorMessage: null,
            telephoneNumber: null,
            outOfHours: null,
            wasSkipped: false,
        };
    },
    props: {
        agency: {
            type: Object,
        },
        branch: {
            type: Object,
        },
        userType: {
            type: String,
        },
    },
    computed: {
        ...mapState('contact', ['sysKey', 'isSkipped']),
        ...mapGetters('contact', ['isBusinessHour']),
        showOOH() {
            // yes this could be refactored to be much smaller but DON'T!
            // the logic has changed a few times so this makes it readable
            // next time there is a query.
            if (this.userType === 'emp') {
                if (this.wasSkipped) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        }
    },
    methods: {
        ...mapMutations('contact', ['setIsSkipped']),
    },
    mounted() {
        this.wasSkipped = this.isSkipped;

        if (!this.isSkipped) {
            this.$emit('registerContact');
        }

        axios
            .get(`/api/agencyTelfax/${this.agency.AgencyTag}`, {
                params: {
                    userType: this.userType,
                    branch: this.branch.branch,
                },
            })
            .then((response) => {
                let responseNumber = response.data.data.telephone;
                if (this.userType === 'emp') {
                    if (this.agency.FAL) {
                        this.telephoneNumber = responseNumber.EmployerTelephone;
                    } else {
                        if (this.wasSkipped) {
                            this.telephoneNumber = responseNumber.AssistedContactTelephone != '' 
                                ? responseNumber.AssistedContactTelephone
                                : responseNumber.EmployerTelephone;
                        } else {
                            this.telephoneNumber = responseNumber.EmployerTelephone;
                        }
                    }
                } else {
                    this.telephoneNumber = responseNumber;
                }
                // this.telephoneNumber = response.data.data.telephone;
                this.outOfHours = response.data.data['out-of-hours'];
            })
            .catch((error) => {
                this.error = true;
                this.errorMessage = error.response.data.message;
            })
            .finally(() => {
                this.fetching = false;
                this.setIsSkipped(false);
            });
    },
};
</script>
